export default "__VITE_ASSET__bfde1b3c__"